<div class="row">
	<div class="col">
		<cache-date></cache-date>
	</div>
</div>

<div class="row">
	<div class="col">
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>
	</div>
</div>

<style>
	thead.fixed_header th {
		position: -webkit-sticky;
		position: sticky;
		top: 1px;
	}
</style>

<div class="row">
	<div class="col">
		<loading [isLoad]="isLoad"></loading>
		
		<table class="table">
			<thead class="fixed_header">
				<tr class="table-primary">
					<th>дата</th>
					<th>заплатили $</th>
					<th>потратили $</th>
					<th>Тратящие пользователи</th>
					<th>median $</th>
					<th>остаток $</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let stat of stats" [sextant]="'balance-' + stat.date">
					<td>
						{{ stat.date | dateFormat:'MMMM YYYY':'ru' }}
					</td>
					
					<td class="show-by-hover">
						<ng-template #popContent>
							<ul>
								<li *ngFor="let h of stat.history">
									заплатили {{h.amount}} $ ({{h.tariffVariant}}) до {{h.dateTo}} ({{h.monthCount}} мес.), потратили: {{h.amountPerMonth}} $
								</li>
							</ul>
						</ng-template>
						
						<div [ngbPopover]="popContent" triggers="mouseenter:mouseleave" popoverTitle="Платежи">
							{{ stat.sum | numberFormat: '1.2-2' }}
						</div>
					</td>
					
					<td>
						{{ stat.amountPerMonth | numberFormat: '1.2-2' }}
					</td>
					
					<td>
						{{ stat.userPerMonth.count }}
					</td>
					
					<td>
						{{ stat.median | numberFormat: '1.2-2' }}
					</td>
					
					<td>
						{{ stat.balance | numberFormat: '1.2-2' }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
